import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import LaserBackground from "@/components/common/LaserBackground";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  
  return (
    <div className="laser-bg min-h-screen">
      <LaserBackground />
      <div className="app-container py-12">
        <button 
          onClick={() => navigate('/')}
          className="btn-download mb-8"
        >
          <ChevronLeft size={18} className="inline mr-2" />
          Volver
        </button>
        
        <div className="form-section max-w-4xl mx-auto">
          <h1 className="font-heading text-3xl text-white mb-2 uppercase tracking-wide text-center">
            Política de Protección de Datos
          </h1>
          <p className="text-[var(--text-muted)] text-center mb-8">
            Web de reservas y venta de entradas
          </p>
          <div className="text-center mb-8">
            <h2 className="font-logo text-2xl">
              <span className="text-[var(--primary)] neon-glow">TAYTANTOS</span>
              <span className="text-white neon-glow text-xl" style={{fontFamily: "'Monoton', cursive"}}>pass</span>
            </h2>
          </div>
          
          <div className="prose prose-invert max-w-none text-[var(--text-muted)] space-y-6">
            <p>
              En cumplimiento del Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo (RGPD) y de la Ley Orgánica 3/2018 de Protección de Datos Personales y Garantía de los Derechos Digitales (LOPDGDD), se informa a los usuarios de esta web de reservas y venta de entradas de lo siguiente:
            </p>
            
            <div className="bg-[var(--surface)] p-6 border-l-4 border-[var(--primary)]">
              <h3 className="text-white font-bold text-lg mb-3">1. Responsable del tratamiento</h3>
              <p>El responsable del tratamiento de los datos personales recabados a través de esta web es:</p>
              <p className="mt-2"><strong className="text-white">TAYTANTOS</strong></p>
              <p>Organización de eventos y festivales musicales.</p>
              <p className="mt-2">Correo electrónico de contacto: <a href="mailto:info@taytantos.com" className="text-[var(--accent-cyan)]">info@taytantos.com</a></p>
            </div>
            
            <div className="bg-[var(--surface)] p-6 border-l-4 border-[var(--accent-cyan)]">
              <h3 className="text-white font-bold text-lg mb-3">2. Datos que se recogen</h3>
              <p>A través de esta web podrán recopilarse los siguientes datos personales:</p>
              <ul className="list-disc ml-6 mt-2 space-y-1">
                <li>Nombre y apellidos</li>
                <li>DNI/NIE o documento identificativo (si fuera necesario para acceso al evento)</li>
                <li>Dirección de correo electrónico</li>
                <li>Número de teléfono</li>
                <li>Datos de facturación</li>
                <li>Datos necesarios para la compra de entradas</li>
                <li>Información técnica de navegación (cookies, dirección IP u otros datos de navegación)</li>
              </ul>
              <p className="mt-3 text-sm">Los datos de pago se procesarán a través de plataformas de pago seguras, sin que TAYTANTOS almacene información completa de tarjetas bancarias.</p>
            </div>
            
            <div className="bg-[var(--surface)] p-6 border-l-4 border-[var(--primary)]">
              <h3 className="text-white font-bold text-lg mb-3">3. Finalidad del tratamiento</h3>
              <p>Los datos personales se tratarán con las siguientes finalidades:</p>
              <ul className="list-disc ml-6 mt-2 space-y-1">
                <li>Gestionar la compra y emisión de entradas para eventos organizados por TAYTANTOS</li>
                <li>Gestionar reservas, accesos y acreditaciones</li>
                <li>Enviar confirmaciones de compra y comunicaciones relacionadas con el evento</li>
                <li>Gestionar incidencias, devoluciones o soporte al cliente</li>
                <li>Informar sobre nuevos eventos, promociones o actividades relacionadas (solo si el usuario lo autoriza)</li>
                <li>Cumplir con obligaciones legales, fiscales o administrativas</li>
              </ul>
            </div>
            
            <div className="bg-[var(--surface)] p-6 border-l-4 border-[var(--accent-cyan)]">
              <h3 className="text-white font-bold text-lg mb-3">4. Legitimación para el tratamiento</h3>
              <p>La base legal para el tratamiento de los datos es:</p>
              <ul className="list-disc ml-6 mt-2 space-y-1">
                <li>La ejecución del contrato de compra de entradas o reserva</li>
                <li>El consentimiento del usuario</li>
                <li>El cumplimiento de obligaciones legales</li>
              </ul>
            </div>
            
            <div className="bg-[var(--surface)] p-6 border-l-4 border-[var(--primary)]">
              <h3 className="text-white font-bold text-lg mb-3">5. Conservación de los datos</h3>
              <p>Los datos personales se conservarán durante:</p>
              <ul className="list-disc ml-6 mt-2 space-y-1">
                <li>El tiempo necesario para la gestión del evento y la compra realizada</li>
                <li>El periodo exigido por la normativa fiscal o administrativa</li>
                <li>Hasta que el usuario solicite su eliminación cuando proceda</li>
              </ul>
            </div>
            
            <div className="bg-[var(--surface)] p-6 border-l-4 border-[var(--accent-cyan)]">
              <h3 className="text-white font-bold text-lg mb-3">6. Cesión de datos</h3>
              <p>Los datos podrán ser comunicados a:</p>
              <ul className="list-disc ml-6 mt-2 space-y-1">
                <li>Plataformas de gestión de entradas o ticketing</li>
                <li>Proveedores tecnológicos necesarios para el funcionamiento de la web</li>
                <li>Plataformas de pago seguro</li>
                <li>Administraciones públicas cuando exista obligación legal</li>
              </ul>
              <p className="mt-3 text-sm font-bold text-white">En ningún caso los datos personales serán vendidos ni cedidos a terceros con fines comerciales.</p>
            </div>
            
            <div className="bg-[var(--surface)] p-6 border-l-4 border-[var(--primary)]">
              <h3 className="text-white font-bold text-lg mb-3">7. Derechos del usuario</h3>
              <p>El usuario puede ejercer en cualquier momento los siguientes derechos:</p>
              <ul className="list-disc ml-6 mt-2 space-y-1">
                <li>Derecho de acceso a sus datos personales</li>
                <li>Derecho de rectificación de datos incorrectos</li>
                <li>Derecho de supresión de datos</li>
                <li>Derecho de limitación del tratamiento</li>
                <li>Derecho de oposición</li>
                <li>Derecho de portabilidad de los datos</li>
              </ul>
              <p className="mt-3">Para ejercer estos derechos puede enviar una solicitud a: <a href="mailto:info@taytantos.com" className="text-[var(--accent-cyan)]">info@taytantos.com</a></p>
              <p className="mt-2 text-sm">También puede presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD) si considera que sus derechos no han sido correctamente atendidos.</p>
            </div>
            
            <div className="bg-[var(--surface)] p-6 border-l-4 border-[var(--accent-cyan)]">
              <h3 className="text-white font-bold text-lg mb-3">8. Uso de imágenes en eventos</h3>
              <p>Durante los eventos organizados por TAYTANTOS podrán realizarse fotografías y grabaciones audiovisuales con fines promocionales, informativos o publicitarios.</p>
              <p className="mt-2">La asistencia al evento implica la posible captación y difusión de la imagen de los asistentes en medios de comunicación, redes sociales o material promocional relacionado con los eventos.</p>
            </div>
            
            <div className="bg-[var(--surface)] p-6 border-l-4 border-[var(--primary)]">
              <h3 className="text-white font-bold text-lg mb-3">9. Seguridad de los datos</h3>
              <p>TAYTANTOS adopta las medidas técnicas y organizativas necesarias para garantizar la seguridad, confidencialidad e integridad de los datos personales, evitando su pérdida, alteración o acceso no autorizado.</p>
            </div>
            
            <div className="bg-[var(--error)]/20 p-6 border border-[var(--error)] mt-8">
              <h3 className="text-[var(--error)] font-bold text-lg mb-3">10. Exención de responsabilidad</h3>
              <p className="text-[var(--error)]">TAYTANTOS no se hace responsable de los incidentes, accidentes, daños personales o materiales, pérdidas, robos o cualquier otro suceso que pueda ocurrir dentro de las instalaciones de la sala o recinto donde se celebre el evento.</p>
              <p className="mt-2 text-[var(--error)]">La responsabilidad sobre la seguridad y el funcionamiento del local corresponde exclusivamente al titular o gestor de dicho establecimiento.</p>
            </div>
          </div>
          
          <div className="text-center mt-12">
            <button 
              onClick={() => navigate('/')}
              className="btn-primary"
            >
              Volver a Inicio
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Payment Success Page

export default PrivacyPolicy;
